import { createContext } from "react";

import { UseGlobalNavProductRecommendationsExperimentResponse } from "../hooks/use-global-nav-product-recommendations-experiment";

const noop = () => {
    // do nothing
};

export const NavProductRecommendationsContext =
    createContext<UseGlobalNavProductRecommendationsExperimentResponse>({
        onGlobalNavProductRecommendationsFailed: noop,
        shouldShowGlobalNavProductRecommendations: false,
        recommendations: [],
        isRecommendationLoading: false,
        mobileNavPageLabelFeaturedProducts: "",
        fireGlobalNavProductRecoEventsWhenInView: noop
    });
